module.exports = __webpack_public_path__ + "static/media/aniket_jayateerth.ca08efeb.jpg";